import { ProgramCountryNominationReviewer } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const getProgramCountryNominationReviewers: (
  fetchContext: FetchContext,
  programId: number,
  countryId: number,
  accessToken?: string,
) => Promise<ProgramCountryNominationReviewer[]> = (fetchContext, programId, countryId, accessToken) => fetch(`${fetchContext.baseUrl}/api/staff/programs/${programId}/countries/${countryId}/nomination-reviewers`,
  {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  })
  .then((response) => responseErrorHandler<ProgramCountryNominationReviewer[]>(fetchContext.errorStore, response, 'get program country nomination reviewers'));
